import { LONG } from 'shared/units/constants'

export function renderStoryTemplate (story, formatDuration, formatDistance) {
  let title = ''

  if (story.template && story.template.title) {
    title = story.template.title.replace(/{{\s*[\w\.]+\s*}}/g, (str) => {
      const propStr = str.replace(/[{}]/g, '')
      const props = propStr.split('.')
      const val = story[props[0]][props[1]]

      if (props[1] === 'distance') {
        return formatDistance({
          value: val,
          unit: LONG,
          digits: 2,
        })
      }

      if (props[1] === 'duration') {
        return formatDuration({
          value: val,
          unit: LONG,
        })
      }

      if (props[0] === 'actor') {
        return `<a href='/profile/${story.actor.id}'>${val}</a>`
      }

      if (story.object.friendship && props[1] === 'title') {
        return `<a href='/profile/${story.object.id}'>${val}</a>`
      }

      return val
    })
  }

  return title
}

export function constructStoryBody (userId, text, privacySetting, file = null) {
  const body = {
    actor: {
      id: userId,
      type: 'user',
    },
    object: {
      text: text,
      type: 'status',
      privacy: privacySetting,
    },
    verb: 'post',
    feed_type: 'public',
    feed_view: 'status',
    id: null,
  }

  if (file) {
    body.attachments = [{
      object: {
        type: 'photo',
      },
    }]
  }

  return body
}
